<template>
  <div class="container">
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tg_title_02.png" alt="" class="title" />
    <div class="content">
      <div class="query-box">
        <h2>自助查询 <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/search_icon.png" alt="" /></h2>
        <div class="form-item">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/location_icon.png" alt="" />
          <span><i>*</i>所在地</span>
          <select v-model="province" :style="{ color: province.length ? '#000' : '#6A6A6A' }">
            <option value="" disable>请选择您所在的省份</option>
            <option value="河南省">河南省</option>
            <option value="北京市">北京市</option>
            <option value="天津市">天津市</option>
            <option value="河北省">河北省</option>
            <option value="山西省">山西省</option>
            <option value="内蒙古自治区">内蒙古自治区</option>
            <option value="辽宁省">辽宁省</option>
            <option value="吉林省">吉林省</option>
            <option value="黑龙江省">黑龙江省</option>
            <option value="上海市">上海市</option>
            <option value="江苏省">江苏省</option>
            <option value="浙江省">浙江省</option>
            <option value="安徽省">安徽省</option>
            <option value="福建省">福建省</option>
            <option value="江西省">江西省</option>
            <option value="山东省">山东省</option>
            <option value="湖北省">湖北省</option>
            <option value="湖南省">湖南省</option>
            <option value="广东省">广东省</option>
            <option value="广西壮族自治区">广西壮族自治区</option>
            <option value="海南省">海南省</option>
            <option value="重庆市">重庆市</option>
            <option value="四川省">四川省</option>
            <option value="贵州省">贵州省</option>
            <option value="云南省">云南省</option>
            <option value="西藏自治区">西藏自治区</option>
            <option value="陕西省">陕西省</option>
            <option value="甘肃省">甘肃省</option>
            <option value="青海省">青海省</option>
            <option value="宁夏回族自治区">宁夏回族自治区</option>
            <option value="新疆维吾尔自治区">新疆维吾尔自治区</option>
            <option value="台湾">台湾</option>
            <option value="香港">香港</option>
            <option value="澳门">澳门</option>
          </select>
          <div class="arrow"></div>
        </div>
        <div class="form-item">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/user_icon.png" alt="" />
          <span><i>*</i>姓<em style="font-style: inherit; visibility: hidden">姓</em>名</span>
          <input type="text" placeholder="请输入您的姓名" v-model="userName" maxlength="10" />
        </div>
        <div class="form-item">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tel_icon.png" alt="" />
          <span><i>*</i>手机号</span>
          <input type="text" placeholder="请输入您的手机号" v-model="phone" maxlength="11" />
        </div>
        <button @click="queryClick">点击查询</button>
        <div class="agree">
          <label>
            <input type="checkbox" v-model="isAgree" style="width: 15px; height: 15px" />
            <p>已阅读并接受《用户服务协议》和《隐私政策》</p>
          </label>
        </div>
      </div>
      <div class="hint-box">
        <h3>友情提示</h3>
        <ul>
          <li>1.本网站为注册二级建造师考生，提供2023年报考条件自助查询服务</li>
          <li>2.请输入正确的手机号码，以免影响查询结果的接收</li>
          <li>3.各省报名时间均有不同，建议提前进行报名咨询，确认自己是否有资格报考注册二级建造师，避免影响考试报名！</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { phoneValidator, isMobile } from '@/utils/index'
import { submitConsult } from '@/api/index.js'
export default {
  data() {
    return {
      province: '',
      userName: '',
      phone: '',
      isAgree: false,
      isLoading: false
    }
  },
  computed: {
    agreeUrl() {
      return isMobile()
        ? 'https://x.zhongke3.com/apis/coursera/common/rich/text/1/71d76ae3eb8e42ce9c5d8151fffc9192'
        : 'https://x.zhongke3.com/zj-wx-web-pc/login/protocol?type=1'
    },
    privacyUrl() {
      return isMobile()
        ? 'https://x.zhongke3.com/apis/coursera/common/rich/text/1/8a6eef758fb44d1db7f0a43834d33edd'
        : 'https://x.zhongke3.com/zj-wx-web-pc/login/protocol?type=2'
    }
  },
  methods: {
    queryClick() {
      if (!this.province.length) {
        return this.$toast.center('请选择您所在的省份')
      }
      if (!this.userName.length) {
        return this.$toast.center('请输入您的姓名')
      }
      if (!this.phone.length) {
        return this.$toast.center('请输入您的手机号')
      }

      if (!phoneValidator(this.phone)) {
        return this.$toast.center('请输入正确的手机号')
      }
      if (!this.isAgree) {
        return this.$toast.center('请勾选协议')
      }

      const gt = new Date().getTime().toString()
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      submitConsult({
        mobile: this.phone,
        name: this.userName,
        area: this.province,
        time: gt,
        encryPwd: md5(gt + 'verify')
      })
        .then(res => {
          if (res.code == 200) {
            this.$toast.center('提交成功')
            setTimeout(() => {
              this.province = ''
              this.userName = ''
              this.phone = ''
              this.isAgree = false
            }, 1000)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  background-image: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tg_bg02.png);

  .title {
    padding-top: 87px;
    padding-bottom: 26px;
    text-align: center;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 1500px;
    height: 780px;
    background-size: 100% 100%;
    background-image: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/content_bg02.png);
    background-repeat: no-repeat;
    .hint-box {
      margin-top: 16px;
      h3 {
        font-size: 26px;
        font-family: Microsoft YaHei;
        color: #de0000;
      }
      ul {
        list-style: none;
        li {
          margin-top: 10px;
          font-size: 20px;
          font-family: Microsoft YaHei;
          color: #302f30;
        }
      }
    }
    .query-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      width: 980px;
      height: 530px;
      background: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/form_bg.png) no-repeat;
      border-radius: 20px;
      h2 {
        display: flex;
        align-items: center;
        padding-top: 38px;
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2379bc;
        img {
          width: 56px;
          height: 56px;
          margin-left: 20px;
        }
      }
      .form-item {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 20px;
        img {
          width: 28px;
          height: 28px;
        }
        span {
          font-size: 22px;
          color: #898989;
          i {
            color: #ee2222;
            font-style: inherit;
          }
        }
        select,
        input {
          width: 318px;
          height: 57px;
          padding-left: 20px;
          margin-left: 15px;
          background: #ffffff;
          font-size: 18px;
          border: 1px solid #d9d9d9;
          box-sizing: border-box;
          border-radius: 6px;
          outline: none;
        }
        select {
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
        .arrow {
          position: absolute;
          top: 0;
          right: 0;
          width: 10px;
          height: 10px;
          margin-right: 16px;
          margin-top: 20px;
          transform: rotate(45deg);
          border-bottom: 1px solid #000;
          border-right: 1px solid #000;
        }
      }
      button {
        width: 200px;
        height: 56px;
        margin-top: 40px;
        font-size: 22px;
        color: #ffffff;
        background: linear-gradient(0deg, #238ad9, #217ec2);
        border-radius: 6px;
        outline: none;
        border: none;
        cursor: pointer;
      }
      .agree {
        label {
          display: flex;
          align-items: center;
          margin-top: 23px;
          cursor: pointer;
          input {
            margin: 0;
          }
          p {
            color: #868686;
            margin: 0 0 0 10px;
            a {
              color: #e5170d;
              text-decoration: none;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .container {
    .title {
      width: 90%;
      padding: 30px 0px;
    }
    .content {
      width: 100%;
      height: auto;
      padding: 0 16px;
      box-sizing: border-box;
      background: none;
      .query-box {
        width: 100%;
        height: 500px;
        background: none;
        zoom: 75%;
        h2 {
          padding-top: 0;
        }
      }
      .hint-box {
        margin-top: 0;
        h3 {
          font-size: 14px;
        }
        ul {
          li {
            margin-top: 5px;
            font-size: 12px;
          }
        }
      }
    }
  }
}

@media (min-width: 993px) and (max-width: 1280px) {
  .container {
    .title {
      padding: 30px 0px;
    }
    .content {
      width: 90%;
      zoom: 80%;
      .query-box {
        zoom: 90%;
      }
    }
  }
}

@media (min-width: 1281px) and (max-width: 1920px) {
  .container {
    .content {
      zoom: 92%;
    }
  }
}
</style>
